import { Button, EmptyState, Page, TopBar } from "../ds";
import { Enlace } from "../router";

export function NoEncontrada() {
  return (
    <>
      <TopBar title="No existe esta página" />
      <Page width="narrow">
        <EmptyState
          icon="search"
          title="Esta dirección no lleva a ninguna pantalla"
          action={
            <Button as={Enlace} href="/" icon="layout-dashboard">
              Ir al tablero
            </Button>
          }
        >
          Puede que el link esté incompleto.
        </EmptyState>
      </Page>
    </>
  );
}
